import { usePopoverContext } from 'components/popover';

/**
 * Alias for `usePopoverContext`.
 * @returns The current `PopoverContext`.
 */
export function useMenuContext() {
  return usePopoverContext();
}
